import React, { useState, useEffect, useRef } from "react";

import { 
  Campaign, 
  CampaignNPC,
  VendorService, 
} from "@dndModels";

import DandDAPI from "@utilities/smart_api";
import { makeStyles } from "@utilities/theme_utilities";

import EditableLabel from "@components/input/strings/EditableLabel";
import FlexBox from "@components/layout/FlexBox";
import StringBox from "@components/input/strings/StringBox";

interface Props {
  campaign: Campaign;
  npc: CampaignNPC;
  vendor_service: VendorService;
}

const api = DandDAPI.getInstance();

export default function VendorServiceInput({ npc, vendor_service }: Props) {
  const [reloading, setReloading] = useState(false);
  // const [processing, setProcessing] = useState(false);
  const [ping, setPing] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);
  
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: '4px',
        marginBottom: '4px',
      },
    });
  });

  const { classes, cx } = useStyles();

  return (
    <FlexBox direction="column">
      <FlexBox direction="row">
        <EditableLabel
          name="Name"
          value={vendor_service.name}
          fontSize={24}
          onChange={ async (changed: string) => {
            vendor_service.name = changed;
            api.upsertObject("campaign_npc", npc);
            setPing(!ping);
          }}
        />
      </FlexBox>
      <FlexBox>
        <StringBox
          name="Details"
          value={vendor_service.description}
          multiline
          onChange={(changed: string) => {
            vendor_service.description = changed;
            api.upsertObject("campaign_npc", npc);
            setPing(!ping);
          }}
        />
      </FlexBox>
      <FlexBox>
        <StringBox
          name="Price"
          value={vendor_service.price}
          onChange={(changed: string) => {
            vendor_service.price = changed;
            api.upsertObject("campaign_npc", npc);
            setPing(!ping);
          }}
        />
      </FlexBox>
    </FlexBox>
  );
}
